const register = {
  loginCredentials: "ข้อมูลรับรองการเข้าสู่ระบบ", // translated
  companyInformation: "ข้อมูล บริษัท", // translated
  contactDetails: "รายละเอียดการติดต่อ", // translated
  businessName: "ชื่อธุรกิจ", // translated
  businessAddress: "ที่อยู่ บริษัท", // translated
  registrationCode: "รหัสลงทะเบียน", // translated
  websiteUrl: "URL ของเว็บไซต์", // translated
  mobilePhone: "โทรศัพท์มือถือ", // translated
  regionStateProvince: "ภูมิภาค/รัฐ/จังหวัด", // translated
  legalTitle: "ชื่อทางกฎหมาย", // translated
  city: "เมือง", // translated
  postalCode: "รหัสไปรษณีย์", // translated
  registrationSuccess: "การลงทะเบียนสำเร็จ", // translated
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome: "กรุณารอสักครู่แล้วคุณจะถูกนำไปที่หน้าแรก", // translated
};

export default register;
